import React, { useEffect, useState, useMemo } from 'react';
import PropTypes from 'prop-types';

import { isRequired } from 'components/Questionnaires/validators';
import LocalisedMessage from 'components/Common/LocalisedMessage';

export const QuestionRadioButtonsField = ({ intl, blockId, question, className, onChange }) => {
  const [inputValue, setInputValue] = useState(question?.answer ?? question.default ?? '');

  const onInputChange = (event) => {
    setInputValue(event.target.value);
    onChange(question, event.target.value);
    return true;
  };

  const items = useMemo(() => {
    if (!question?.componentProps?.items) {
      return [];
    }

    if (typeof question.componentProps.items === 'string') {
      const itemsArray = intl.messages[question.componentProps.items] ?? [];
      return (typeof itemsArray === 'string') ? [] : itemsArray;
    }
    if (Array.isArray(question.componentProps.items)) {
      return question.componentProps.items;
    }
    return [];
  }, [question?.componentProps?.items, intl]);

  useEffect(() => {
    if (inputValue) {
      onChange(question, inputValue);
    }
  }, []);

  useEffect(() => {
    setInputValue(question.answer ?? question.default ?? '');
  }, [question.answer]);

  function getLabel(option) {
    if (!option.label) {
      return option.value;
    }

    return question?.componentProps?.preventTranslation === true
      ? option.label
      : <LocalisedMessage id={ option.label } />;
  }

  return (<div
    className={ `radio-container ${ className }` }
    id={ `${ blockId }-${ question.id }` }
    role="radiogroup"
    aria-required={ isRequired(question) }
    aria-describedby={ question.isValid === false ? (`${ blockId }-${ question.id }-error`) : undefined }
    aria-labelledby={ `${ blockId }-${ question.id }-lbl` }
  >
    {items.map(i => (
      <div
        className="ml-3"
        key={ `${ blockId }-${ question.id }-${ i.value }` }
      >
        <input
          name={ `${ question?.componentProps?.inputName }` }
          id={ `${ blockId }-${ question.id }-${ i.value }` }
          value={ i.value }
          type="radio"
          aria-checked={ inputValue === i.value }
          onClick={ e => onInputChange(e) }
        />
        <label
          htmlFor={ `${ blockId }-${ question.id }-${ i.value }` }
        >
          {getLabel(i)}
        </label>
      </div>
    ))}

  </div>);
};

QuestionRadioButtonsField.displayName = 'QuestionRadioButtonsField';

QuestionRadioButtonsField.propTypes = {
  intl: PropTypes.shape().isRequired,
  blockId: PropTypes.string.isRequired,
  question: PropTypes.shape().isRequired,
  className: PropTypes.string,
  items: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired
};

QuestionRadioButtonsField.defaultProps = {
  className: '',
};

export default QuestionRadioButtonsField;
